import { render } from "./NowUploadPopup.vue?vue&type=template&id=5e87431e&scoped=true&ts=true"
import script from "./NowUploadPopup.vue?vue&type=script&lang=ts"
export * from "./NowUploadPopup.vue?vue&type=script&lang=ts"

import "./NowUploadPopup.vue?vue&type=style&index=0&id=5e87431e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e87431e"]])

export default __exports__